<div class="portal-form-answers-panel bg-white border rounded shadow-sm mt-1">
  <div class="portal-form-answers-header d-flex align-items-center justify-content-between gap-3 flex-wrap">
    <div class="d-flex align-items-center gap-3">
      <span class="portal-form-answers-icon d-inline-flex align-items-center justify-content-center rounded">
        <i class="bi bi-ui-checks-grid"></i>
      </span>
      <div>
        <p class="mb-1 fw-bold text-sm text-dark">Section Form Responses</p>
      </div>
    </div>
  </div>

  <div v-if="loading" class="portal-form-answers-state text-center">
    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
    <p class="mb-0 mt-2 text-muted text-xxs">Loading submitted forms...</p>
  </div>

  <div v-else-if="has_form_answer_tables() || loading_portal_forms_answers" class="portal-form-answers-list">
    <div
      v-for="form_table in form_tables"
      :key="form_table.form.id"
      class="portal-form-answer-card"
    >
      <div class="portal-form-answer-card-header d-flex align-items-start justify-content-between gap-3 flex-wrap">
        <div>
          <p class="mb-1 fw-bold text-sm text-dark">{{ form_table.form.name }}</p>
          <p v-if="form_table.form.description" class="mb-0 text-muted text-xxs">{{ form_table.form.description }}</p>
          <div class="d-flex align-items-center gap-2 flex-wrap mt-2">
            <span class="portal-form-answer-meta rounded">{{ form_table.rows.length }} Responses</span>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-outline-primary text-xxs rounded px-3"
          @click="export_personal_profile_form_table(form_table)"
        >
          <i class="bi bi-download me-1"></i> Export CSV
        </button>
      </div>

      <div class="portal-form-answer-table-shell table-responsive">
        <table
          :id="`personal-profile-form-table-${form_table.form.id}`"
          class="table table-sm align-middle mb-0 personal-profile-form-table"
        >
          <thead>
            <tr>
              <th class="text-xxs text-nowrap">User</th>
              <th class="text-xxs text-nowrap">Email</th>
              <th class="text-xxs text-nowrap">Location</th>
              <th class="text-xxs text-nowrap">DOB</th>
              <th class="text-xxs text-nowrap">Race</th>
              <th class="text-xxs text-nowrap">Gender</th>
              <th
                v-for="question in form_table.questions"
                :key="question.id"
                class="text-xxs portal-form-question-heading"
                style="min-width: 180px;"
              >
                {{ question.question }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in form_table.rows"
              :key="`${form_table.form.id}-${row.base_profile_id}`"
            >
              <td class="text-xs fw-semibold">{{ get_personal_profile_user_name(row.user) }}</td>
              <td class="text-xs">{{ row.user?.email || '-' }}</td>
              <td class="text-xs">{{ row.location || '-' }}</td>
              <td class="text-xs">{{ row.date_of_birth || '-' }}</td>
              <td class="text-xs">{{ row.race || '-' }}</td>
              <td class="text-xs">{{ row.gender || '-' }}</td>
              <td
                v-for="question in form_table.questions"
                :key="`${row.base_profile_id}-${question.id}`"
                class="text-xs"
              >
                <div class="text-break">{{ get_personal_profile_answer_cell(row, question.id).text }}</div>
                <div v-if="get_personal_profile_answer_cell(row, question.id).files.length" class="d-flex flex-column gap-1 mt-2">
                  <a
                    v-for="file_item in get_personal_profile_answer_cell(row, question.id).files"
                    :key="file_item.id"
                    :href="file_item.file?.s3_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-xxs"
                  >
                    {{ file_item.file?.name || 'Open file' }}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="loading_portal_forms_answers" class="portal-form-answers-state text-center">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      <p class="mb-0 mt-2 text-muted text-xxs">Loading submitted forms...</p>
    </div>
    <div
      v-for="form_table in portal_form_tables"
      :key="form_table.id"
      class="portal-form-answer-card"
    >
      <div class="portal-form-answer-card-header d-flex align-items-start justify-content-between gap-3 flex-wrap">
        <div>
          <p class="mb-1 fw-bold text-sm text-dark">{{ form_table.form.name }}</p>
          <p v-if="form_table.form.description" class="mb-0 text-muted text-xxs">{{ form_table.form.description }}</p>
          <div class="d-flex align-items-center gap-2 flex-wrap mt-2">
            <span class="portal-form-answer-meta rounded">{{ form_table.rows.length }} Responses</span>
          </div>
        </div>
        <button
          class="btn btn-light border rounded-circle text-secondary p-0 px-1 shadow-sm d-inline-flex align-items-center justify-content-center flex-shrink-0"
          type="button"
          @click="toggle_portal_answer_table(form_table.id)"
          :aria-expanded="is_portal_answer_table_open(form_table.id)"
          :aria-controls="`portal-form-answer-table-panel-${form_table.form.id}`"
        >
          <i
            class="bi"
            :class="is_portal_answer_table_open(form_table.id) ? 'bi-chevron-up' : 'bi-chevron-down'"
          ></i>
        </button>
      </div>

      <div
        v-if="is_portal_answer_table_open(form_table.id)"
        :id="`portal-form-answer-table-panel-${form_table.form.id}`"
        class="portal-form-answer-table-shell table-responsive"
      >
        <table
          :id="`portal-form-answer-table-${form_table.form.id}`"
          class="table table-sm align-middle mb-0 personal-profile-form-table"
        >
          <thead>
            <tr>
              <th class="text-xxs text-nowrap">User</th>
              <th class="text-xxs text-nowrap">Email</th>
              <th
                v-for="question in form_table.questions"
                :key="question.id"
                class="text-xxs portal-form-question-heading"
                style="min-width: 180px;"
              >
                {{ question.question }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in form_table.rows"
              :key="`${form_table.id}-${row.base_profile_id}`"
            >
              <td class="text-xs fw-semibold text-nowrap">{{ get_personal_profile_user_name(row.user) }}</td>
              <td class="text-xs text-nowrap">{{ row.user?.email || '-' }}</td>
              <td
                v-for="question in form_table.questions"
                :key="`${row.base_profile_id}-${question.id}`"
                class="text-xs"
              >
                <div class="text-break">{{ get_personal_profile_answer_cell(row, question.id).text }}</div>
                <div v-if="get_personal_profile_answer_cell(row, question.id).files.length" class="d-flex flex-column gap-1 mt-2">
                  <a
                    v-for="file_item in get_personal_profile_answer_cell(row, question.id).files"
                    :key="file_item.id"
                    :href="file_item.file?.s3_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-xxs"
                  >
                    {{ file_item.file?.name || 'Open file' }}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div v-else class="portal-form-answers-state text-center text-muted">
    <span class="portal-form-answers-empty-icon d-inline-flex align-items-center justify-content-center rounded-circle mb-3">
      <i class="bi bi-inbox"></i>
    </span>
    <p class="mb-1 fw-semibold text-dark text-xs">No form answers yet</p>
    <p class="mb-0 text-xxs">Submitted personal profile forms will appear here.</p>
  </div>
</div>
